import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import { TextField } from 'components/TextField/TextField';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { SignupFormData, SignUpUserType } from 'features/signUp/types';

interface LastNameEligibilityCheckStepProps {
  signUpUserType: SignUpUserType;
}

export const LastNameEligibilityCheckStep = ({
  signUpUserType,
}: LastNameEligibilityCheckStepProps) => {
  const { translation } = useTranslationContext();
  const {
    register,
    formState: { errors },
  } = useFormContext<SignupFormData>();
  const { ref, onChange, onBlur, name, required } = register('memberLastName', {
    setValueAs: (value) => value.trim(),
    required: translation('empty_field_error'),
  });

  return (
    <Stack spacing={4} className="member-last-name-verification-step">
      <Typography variant="h5" color="primary" id="last-name-verification-header">
        {signUpUserType === 'member'
          ? translation('eligibility_lastname_header')
          : translation('eligibility_lastname_caregiver_header')}
      </Typography>
      <TextField
        id="signup_last-name-input"
        label={translation('last_name')}
        name={name}
        inputRef={ref}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        error={!!errors.memberLastName}
        helperText={errors.memberLastName?.message}
        aria-labelledby="last-name-verification-header"
      />
    </Stack>
  );
};
